export default __webpack_public_path__ + "static/9e20d1e0370308ef741ff188e1852c72.jpg";